export default __webpack_public_path__ + "static/media/97.a69f5d01.jpeg";